import { Res, DocumentType, WhenPrint } from 'core/api';
import { SessionProvider } from 'core/infrastructure';
import { Message } from 'core/ui-next/modal';

async function shouldPrint(whenPrint: WhenPrint): Promise<boolean> {

	if (whenPrint === WhenPrint.Always)
		return true;

	if (whenPrint === WhenPrint.Never)
		return false;

	const result = await Message.confirm(Res.Web.CHECK_TICKET_PRINT_OPTIONS_PRINT_TICKET_LBL());
	return result.ok;
}

export async function shouldPrintInvoice(invoiceType: DocumentType): Promise<boolean> {
	const session = SessionProvider.getCurrent();

	const isBasic = [DocumentType.BasicInvoice, DocumentType.BasicRefund].includes(invoiceType);
	const whenPrint = isBasic ? session.TicketWhenPrint : session.InvoiceWhenPrint;

	return await shouldPrint(whenPrint);
}

export async function shouldPrintDeliveryNote(): Promise<boolean> {
	const whenPrint = SessionProvider.getCurrent().DeliveryNoteWhenPrint;
	return await shouldPrint(whenPrint);
}

export async function shouldPrintSalesOrder(): Promise<boolean> {
	// Usar DeliveryNoteWhenPrint *no* es un bug: las opciones de DeliveryNote se usan también para los pedidos
	const whenPrint = SessionProvider.getCurrent().DeliveryNoteWhenPrint;
	return await shouldPrint(whenPrint);
}
